import PropTypes from 'prop-types';
import { parseSortOptions } from '@/utils/categUtils';
import SelectDropdown from '@/components/common/SelectDropdown';
import { SORT } from '@/constants/categ';

export const SortDesktop = ({ t, selectedSort, onSortChange, isProducerCategory }) => {
  const enhancedSort = [
    ...SORT,
    isProducerCategory && { value: 12, label: 'byMillesimeAsc' },
    isProducerCategory && { value: 13, label: 'byMillesimeDesc' },
  ].filter(Boolean);

  const selectedOption = enhancedSort.find((opt) => opt.value === selectedSort);

  const handleOnChange = (element) => {
    onSortChange(element.value);
  };

  return (
    <SelectDropdown onChange={handleOnChange} selected={selectedOption} options={parseSortOptions(t, enhancedSort)} />
  );
};

SortDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  selectedSort: PropTypes.number,
  onSortChange: PropTypes.func.isRequired,
};

export default SortDesktop;
